module.exports = __webpack_public_path__ + "img/MONA-alt.21abd7b1.svg";